var pick = function pick(props, obj) {
  return props.reduce(function (acc, prop) {
    acc[prop] = obj[prop];
    return acc;
  }, {});
};
var SIZING_STYLE = ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'boxSizing', 'fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'letterSpacing', 'lineHeight', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop', 'tabSize', 'textIndent', 'textRendering', 'textTransform', 'width', 'wordBreak'];
export var getSizingData = function getSizingData(node) {
  var _window$getComputedSt, _window;
  if (!node) {
    return null;
  }
  var style = (_window$getComputedSt = (_window = window) === null || _window === void 0 ? void 0 : _window.getComputedStyle(node)) !== null && _window$getComputedSt !== void 0 ? _window$getComputedSt : {};
  var sizingStyle = pick(SIZING_STYLE, style);
  var boxSizing = sizingStyle.boxSizing;
  if (boxSizing === '') {
    return null;
  }
  var paddingSize = {
    vertical: parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop),
    horizontal: parseFloat(sizingStyle.paddingLeft) + parseFloat(sizingStyle.paddingRight)
  };
  var borderSize = {
    vertical: parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth),
    horizontal: parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.borderRightWidth)
  };
  return {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize
  };
};
export default getSizingData;